<div
  #logoDropdown
  class="d-flex justify-content-center align-items-center px-2"
  (touchstart)="handleMobileTouch()"
  (mouseup)="handleDesktopClick()"
  (mouseenter)="handleMouseEnter()"
  [ngClass]="{
    'd-xl-flex': isLogged(),
    opened: logoDropdownOpened(),
    logo: navDataService.ikoLogoCenterMobileVar,
    'rounded logoDropdown dropdown dropdown-toggle bg-primary-dark': !navDataService.ikoLogoCenterMobileVar
  }"
>
  <img class="navbar-image me-1" width="125" height="45" src="/assets/images/iko-logo.svg" priority alt="IKO Logo" />
  <div
    (touchend)="openIWO($event)"
    (mousedown)="openIWO($event)"
    class="d-none box-shadow position-absolute w-100 align-items-center bg-primary-dark px-2 rounded-bottom"
  >
    <img class="navbar-image no-hover" width="300" height="45" src="/assets/images/iwo-logo.svg" alt="IWO Logo" />
  </div>
</div>
